<template>
	<!-- SideMenu(rightside) -->
	<aside
		:class="{active: scrollY > 100}"
		class="iv2-extra-nav theme-b__extra-bg text-center d-none d-xl-block"
	>
		<nav class="iv2-extra-nav__sub-menu">
			<ul class="iv2-extra-nav__sub-list list-unstyled">
				<li v-for="nav in extra_menu" :key="nav.id" class="iv2-extra-nav__sub-item theme-b__extra-text">
					<router-link
						v-if="nav.link_type == 'internal'"
						:to="nav.url"
						@click.native="activeMenu = false"
						class="iv2-extra-nav__sub-link theme-b__extra-link"
					>
						<i
							:class="
                                'iv2-extra-nav__sub-item-icon d-block ' +
                                    nav.icon
                            "
						></i>
						<span class="iv2-extra-nav__sub-item-text d-block">
							{{
							nav.name
							}}
						</span>
					</router-link>
					<a
						v-else-if="nav.link_type == 'external'"
						v-bind:href="nav.url"
						:target="nav.target_type"
						rel="noopener"
						class="iv2-extra-nav__sub-link theme-b__extra-link"
					>
						<i
							:class="
                                'iv2-extra-nav__sub-item-icon d-block ' +
                                    nav.icon
                            "
						></i>
						<span class="iv2-extra-nav__sub-item-text d-block">
							{{
							nav.name
							}}
						</span>
					</a>
					<div v-else-if="nav.link_type == 'push'" class="iv2-extra-push-button">
						<button
							class="iv2-extra-nav__sub-link theme-b__extra-link"
							style="background-color: transparent; border: none; margin: 0 auto;"
						>
							<i
								:class="
                                    'iv2-extra-nav__sub-item-icon d-block ' +
                                        nav.icon
                                "
							></i>
							<span class="iv2-extra-nav__sub-item-text d-block">{{ nav.name }}</span>
						</button>
					</div>
				</li>
			</ul>
		</nav>
	</aside>
</template>

<script>
export default {
	data() {
		return {
			extra_menu: [],

			scrollY: 0,
		};
	},

	created() {
		this.axios.get("/json/navigations.json").then((response) => {
			this.extra_menu = response.data.navs.extra_menu;
		});

		window.addEventListener("scroll", this.handleScroll);
	},

	methods: {
		handleScroll: function () {
			this.scrollY = window.scrollY;
		},
	},
};
</script>

<style lang="scss">
.iv2-extra-nav {
	top: 110px;
	right: 0;
	transition: 0.3s;
	&.active {
		top: 70px;
	}

	.iv2-extra-nav__sub-menu {
		.iv2-extra-nav__sub-list {
			margin-bottom: 0;
			height: 100%;
			.iv2-extra-nav__sub-item {
				position: relative;

				&:last-child {
					&::after {
						content: none;
					}
				}

				.iv2-extra-nav__sub-link {
					padding: 17px 10px;
					-webkit-transition: 0.3s;
					transition: 0.3s;
					display: block;

					&:hover {
						text-decoration: none;
						opacity: 0.5;
					}
				}

				.iv2-extra-nav__sub-item-icon {
					font-size: 1.1rem;
					margin-bottom: 6px;
				}

				.iv2-extra-nav__sub-item-text {
					font-size: 8px;
					line-height: 1.3;
				}
			}
		}
	}
}
</style>
